import { render, staticRenderFns } from "./editPropertyRightRegistrationDetail.vue?vue&type=template&id=94ffe5a4&scoped=true"
import script from "./editPropertyRightRegistrationDetail.vue?vue&type=script&lang=js"
export * from "./editPropertyRightRegistrationDetail.vue?vue&type=script&lang=js"
import style0 from "./editPropertyRightRegistrationDetail.vue?vue&type=style&index=0&id=94ffe5a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ffe5a4",
  null
  
)

export default component.exports